module.exports = {
  title: '業務區域資料',
  schema: {
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        name: '區域代碼',
      },
      name: {
        type: 'String',
        name: '區域名稱',
      },
    },
  },
  index: {
    primary: {
      key: {
        key: 1,
      },
      unique: true,
    },
  },
  list: {
    ui: {
      fields: [
        { path: 'key' },
        { path: 'name' },
      ],
    },
  },
  edit: {
    ui: [
      {
        name: 'formEditor',
        cols: { default: 500 },
        fields: [
          [{ path: 'key' }],
          [{ path: 'name' }],
        ],
      },
    ],
  },
}
